import React, { useState } from 'react';
import {FaRegCircleQuestion} from "react-icons/fa6";
import * as Yup from "yup";
import {ErrorMessage, Field, Form, Formik} from "formik";
import {communityService} from "../../services/communityService/communityService";
import {toast} from "react-toastify";
import ModalClose from "../../assets/modal_close.png";
import CloudUpload from "../../assets/Cloud_Upload.png";
import wordIcon from "../../assets/projects/word_file.png";
import pptIcon from "../../assets/projects/ppt_file.png";
import pdfIcon from "../../assets/projects/pdf_file.png";
import {IoMdClose} from "react-icons/io";

function HelpButton() {
    const [showModal, setShowModal] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [resourceFiles, setResourceFiles] = useState([]);
    const [fileUploads, setFileUploads] = useState([]);

    const handleOpen = () => setShowModal(true);
    const handleClose = () => setShowModal(false);

    const MAX_LENGTH = 1000;
    const MIN_LENGTH = 20;

    const validationSchema = Yup.object({
        email: Yup.string()
            .email('Enter a correct email')
            .required('Email required'),
        message: Yup.string()
            .min(MIN_LENGTH, `Minimum ${MIN_LENGTH} characters`)
            .max(MAX_LENGTH, `Maximum ${MAX_LENGTH} characters`)
            .required('Issue description required'),
    });

    const handleFileInputChange = (e) => {
        const files = Array.from(e.target.files);
        handleFiles(files);
    };

    const handleFileDrop = (e) => {
        e.preventDefault();
        const files = Array.from(e.dataTransfer.files);
        handleFiles(files);
    };

    const handleFiles = (files) => {
        const previews = files.map(file => URL.createObjectURL(file));
        setSelectedFiles(prev => [...prev, ...files.map(file => file.name)]);
        setResourceFiles(prev => [...prev, ...files]);
        setFileUploads(prev => [...prev, ...previews]);
    };

    const removeFile = (index) => {
        setSelectedFiles(prev => prev.filter((_, i) => i !== index));
        setResourceFiles(prev => prev.filter((_, i) => i !== index));
        setFileUploads(prev => prev.filter((_, i) => i !== index));
    };

    const getFileIcon = (fileName, previewURL) => {
        return <img crossOrigin="anonymous" src={previewURL} className="uploaded-file" width={300} alt="Uploaded Preview" />;
    };

    return (
        <>
            <button
                type="button"
                onClick={handleOpen}
                className="btn btn-primary rounded-5 position-fixed"
                style={{
                    bottom: '1.5rem',
                    right: '1.5rem',
                    zIndex: 1050,
                    padding: '0.5rem 1rem',
                    fontSize: '1rem',
                    fontWeight: 700,
                    alignItems: 'center',
                    display: 'flex',
                    backgroundColor: '#8a6845',
                    border: 'none'
                }}
                aria-label="Open support"
            >
                <FaRegCircleQuestion className="mr-5" />
                Help
            </button>

            {showModal && (
                <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }} onClick={handleClose}>
                    <div className="modal-dialog" role="document" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-content">
                            <Formik
                                initialValues={{ email: '', message: '' }}
                                validationSchema={validationSchema}
                                onSubmit={async (values, actions) => {
                                    try {
                                        const formData = new FormData();
                                        formData.append('email', values.email);
                                        formData.append('message', values.message);
                                        resourceFiles.forEach((file, index) => {
                                            formData.append(`attachments[${index}]`, file);
                                        });
                                        await communityService.helpRequestMessage(formData);
                                        toast.success("Message was sent successfully.");
                                        handleClose();
                                    } catch (error) {
                                        console.error('Error sending message: ', error);
                                    } finally {
                                        actions.setSubmitting(false);
                                    }
                                }}
                            >
                                {({ values, handleChange, handleBlur, isSubmitting }) => (
                                    <Form>
                                        <div className="modal-header">
                                            <h5 className="modal-title">Contact Support</h5>
                                            <button type="button" className="btn-close" onClick={handleClose} aria-label="Close" />
                                        </div>
                                        <div
                                            className="modal-body d-block"
                                            onDragOver={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                            }}
                                            onDragEnter={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                            }}
                                            onDragLeave={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                            }}
                                            onDrop={handleFileDrop}
                                        >
                                            <p>Describe your problem, and we’ll get back to you via email as soon as we can!</p>

                                            {/* Email */}
                                            <div className="mb-3">
                                                <label htmlFor="email" className="form-label">Your Email</label>
                                                <Field
                                                    type="email"
                                                    name="email"
                                                    id="email"
                                                    className="form-control"
                                                />
                                                <div className="form-text text-danger">
                                                    <ErrorMessage name="email" />
                                                </div>
                                            </div>

                                            <div className="mb-3">
                                                <label htmlFor="message" className="form-label">Describe Your Issue</label>
                                                <textarea
                                                    id="message"
                                                    name="message"
                                                    rows="5"
                                                    className="form-control"
                                                    maxLength={MAX_LENGTH}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.message}
                                                />
                                                <div className="form-text text-danger">
                                                    <ErrorMessage name="message" />
                                                </div>

                                                {MAX_LENGTH - values.message.length <= 150 && (
                                                    <div className="form-text text-muted text-end">
                                                        {MAX_LENGTH - values.message.length} / {MAX_LENGTH} characters left
                                                    </div>
                                                )}
                                            </div>

                                            <div className="dropzone">
                                                <div className="row mt-3 px-3">
                                                    <div className="box col-sm-12 col-lg-12 col-md-12 flex-column gap-1">
                                                        <div className="d-flex flex-column gap-3 w-100">
                                                            <h5 className="text-black m-0">
                                                                Optional include attachments or screenshots of your issue:
                                                            </h5>
                                                            <div className=" w-full box-3 ">
                                                                <div className="selected-file-box">
                                                                    {selectedFiles.length > 0 ? (
                                                                        selectedFiles.map((fileName, index) => (
                                                                            <div key={index} className="uploaded-file-wrapper mb-3">
                                                                                <div className="d-flex justify-content-between align-items-center">
                                                                                    <h6 className="m-0">{fileName}</h6>
                                                                                    <div className="cursor-pointer" onClick={() => removeFile(index)}>
                                                                                        <IoMdClose alt="Close" />
                                                                                    </div>
                                                                                </div>
                                                                                <div className="selected-file-name mt-2">
                                                                                    {getFileIcon(fileName, fileUploads[index])}
                                                                                </div>
                                                                            </div>
                                                                        ))
                                                                    ) : (
                                                                        <label htmlFor="fileInput" className="resources-file-uploaded text-center">
                                                                            <img crossOrigin="anonymous" src={CloudUpload} alt="Upload Icon" />
                                                                            <div className="text-1 mt-3 text-center">Select or drop files here</div>
                                                                            <div className="text-2 text-center">Max total size: 10MB each</div>
                                                                            <div className="text-2 text-center">Extensions: .jpg, .jpeg, .png</div>
                                                                        </label>
                                                                    )}
                                                                </div>
                                                                <input
                                                                    type="file"
                                                                    id="fileInput"
                                                                    name="resource_file"
                                                                    accept=".jpg, .jpeg, .png"
                                                                    multiple
                                                                    className="offscreen"
                                                                    onClick={(e) => {
                                                                        e.target.value = null;
                                                                    }}
                                                                    onChange={handleFileInputChange}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="modal-footer">
                                            <button type="button" className="btn btn-secondary" onClick={handleClose}>Close</button>
                                            <button
                                                className="btn btn-primary"
                                                disabled={isSubmitting}
                                            >
                                                {isSubmitting ? (
                                                    <>
                                                        <span
                                                            className="spinner-border spinner-border-sm me-2"
                                                            role="status"
                                                            aria-hidden="true"
                                                        ></span>
                                                        Sending...
                                                    </>
                                                ) : (
                                                    "Send"
                                                )}
                                            </button>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default HelpButton;